<template>
    <div class="container pl-6">
        <v-tabs
            v-model="tab"
            tile
            height="35"
            :background-color="$vuetify.theme.dark ? 'black' : 'grey lighten-1'"
        >
            <v-tab
                v-for="item in markets"
                :key="item.tab"
                class="caption pa-0 grey--text font-weight-bold"
            >
                {{ $t(item.tab) }}
            </v-tab>
            <v-tabs-items v-model="tab" class="transparent">
                <v-tab-item v-for="item in markets" :key="item.tab">
                    <v-card flat class="transparent pa-0">
                        <v-card-text class="px-0 mt-2">
                            <component :is="item.content"></component>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </v-tabs>
    </div>
</template>

<script>
import About from "@/components/fairplay/markets/Cricket/About"
import Tutorial from "@/components/fairplay/markets/Cricket/Tutorial"
import Upcoming from "@/components/fairplay/markets/Cricket/Upcoming"
export default {
    components: { About, Tutorial, Upcoming },
    data() {
        return {
            tab: 0,
            markets: [
                {
                    tab: "market.about_market",
                    content: "About"
                }
                // {
                //   tab: 'Tutorials',
                //   content: 'Tutorial'
                // },
                // {
                //   tab: 'Upcoming Markets',
                //   content: 'Upcoming'
                // }
            ]
        }
    },
    head() {
        return {
            title: `Play Cricket Online and Earn Money with ${process.env.APP_TITLE} | Sign Up Today!`,
            meta: [
                {
                    hid: "description",
                    name: "description",
                    content: `Enjoy online cricket betting with ${process.env.APP_TITLE} – world's first official betting website that makes online gambling an amusing and exciting form of entertainment. Sign up now!`
                },
                {
                    name: "keywords",
                    content: `play cricket online, play online cricket games, cricket betting, cricket betting online, cricket betting odds, cricket betting sites, cricket bet, live cricket betting rates, cricket betting today, play cricket online and earn money, play cricket and earn money`
                }
            ]
        }
    }
}
</script>
